import { render, staticRenderFns } from "./BRating.vue?vue&type=template&id=2b4c7246&scoped=true"
import script from "./BRating.vue?vue&type=script&lang=js"
export * from "./BRating.vue?vue&type=script&lang=js"
import style0 from "./BRating.vue?vue&type=style&index=0&id=2b4c7246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c7246",
  null
  
)

export default component.exports